import { render, staticRenderFns } from "./P0147.vue?vue&type=template&id=5f325474&scoped=true&"
import script from "./P0147.vue?vue&type=script&lang=ts&"
export * from "./P0147.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f325474",
  null
  
)

export default component.exports